var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlogrightarrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 12,
    viewBox: "0 0 8 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.969668 11.5303C0.676777 11.2374 0.676777 10.7626 0.969668 10.4697L5.4393 6L0.969668 1.53033C0.676777 1.23744 0.676777 0.762558 0.969668 0.469668C1.26256 0.176777 1.73744 0.176777 2.0303 0.469668L7.0303 5.4697C7.171 5.6103 7.25 5.8011 7.25 6C7.25 6.1989 7.171 6.3897 7.0303 6.5303L2.0303 11.5303C1.73744 11.8232 1.26256 11.8232 0.969668 11.5303Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlogrightarrow);
export default __webpack_public_path__ + "static/media/blogrightarrow.6eda7143dc8b5af4afa27da0cfe6af01.svg";
export { ForwardRef as ReactComponent };